// @flow
import { format, newDate } from 'date-fns-jalali';
import { Box, Stack } from '@mui/material';
import useI18n from '@shared/helper/hooks/useI18n';
import convertDate from '@shared/utils/convertDate';

function DateTime({ value }: { value: string }): React$Node {
	const { translate } = useI18n('finoShared');

	if (!value) {
		return translate('dateIsNotEntered');
	}

	const { year, month, day, hours, minutes } = convertDate(value);

	const date = format(newDate(year, month - 1, day, hours, minutes), 'P');
	const time = format(newDate(year, month - 1, day, hours, minutes), 'HH:mm');

	return (
		<Stack>
			<Box>{date}</Box>
			<Box>{time}</Box>
		</Stack>
	);
}

export default DateTime;
